export const MAX_STATS = 999;